module.exports = __webpack_public_path__ + "static/media/home_bg.4d260b24.png";